import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Ads } from 'app/models/ads';
import { AdsService } from 'app/services/ads/ads.service';
import { AwscontrolService } from 'app/services/aws/awscontrol.service';

@Component({
  selector: 'app-modifier-ads',
  templateUrl: './modifier-ads.component.html',
  styleUrls: ['./modifier-ads.component.scss']
})
export class ModifierAdsComponent implements OnInit {

  selectedFiles1: FileList;
  fileNames :any=[]
  photourl!: string
  allAttch:any[] =[];
  public image! : string
  isEditMode = false;
  adsForm: NgForm;
  adsData: Ads;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public getRandomString(length:any) {

    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }
  uploadimg2() {

    let i=0
    console.log(this.selectedFiles1)
    for (i=0; i<this.selectedFiles1.length;i++ ){
      const file = this.selectedFiles1[i];
      this.uploadFileimg2(file);
      
    }
    
    // console.log(file)
  }
  selectFileimg(e:any) {
    this.selectedFiles1 = e.target.files;
    
    this.uploadimg2();
  }
  async uploadFileimg2(file:any) {
    this.fileNames.push(file.name)
    const contentType = file.type;
    
    // Use AwscontrolService instead of direct S3
    const renamedFile = new File([file], `${this.getRandomString(5)}_${file.name}`, { type: contentType });
    
    this.awsService.uploadFile(renamedFile, 'ads-images').subscribe(
      (response) => {
        if (response.success && response.urls.length > 0) {
          const userImg = response.urls[0];
          console.log(userImg)
          localStorage.setItem('userImg',JSON.stringify(userImg) )
          
          this.allAttch.push(userImg)
          console.log(this.allAttch)
          this.image=userImg;
        }
      },
      (err) => {
        console.log('There was an error uploading your file: ', err);
      }
    );
  }

  constructor(private adsService:AdsService, private awsService: AwscontrolService) {
    this.adsData = {} as Ads;

   }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;

    // Fetch All Students on Page load
    this.getAllAds()
  }

  getAllAds() {
    this.adsService.getListAds().subscribe((response: any) => {
      this.dataSource.data = response;
    });
  }

  addAds() {
    this.adsService.createAds(this.adsData).subscribe((response: any) => {
      this.dataSource.data.push({ ...response })
      this.dataSource.data = this.dataSource.data.map(o => {
        return o;
      })
    });
  }
  cancelEdit() {
    this.isEditMode = false;
    this.adsForm.resetForm();
  }
  updateAds() {
    this.adsService.updateAds(this.adsData.id, this.adsData).subscribe((response: any) => {

      this.dataSource.data = this.dataSource.data.map((o: Ads) => {
        if (o.id === response.id) {
          o = response;
        }
        return o;
      })

     

    this.cancelEdit()

    });
  }

  onSubmit() {
    if (this.adsForm.form.valid) {
      if (this.isEditMode)
        this.updateAds()
      else
        this.addAds();
    } else {
      console.log('Enter valid data!');
    }
  }

  csvInputChange(fileInputEvent: any) {
    console.log(fileInputEvent.target.files[0]);
  }
}